<template lang="pug">
  .local-store
    img.local-store__logo(
      :alt="store.retailerName"
      v-if="logoSrc"
      :src="logoSrc"
    )
    .local-store__address.body--xs() {{ store.retailerAddress }}
    .local-store__availability.body--xs() 
      icon.local-store__stock-icon(
        v-if="store.availability !== 'hidden'"
        :name="store.availability ? 'check' : 'close'"
        size="14px"
      )
      span {{ stockText }}
    .local-store__price.body--xs
      span(v-if="store.price") ${{ store.price }}
    v-button.btn--shop-now(
      htmlTag="a"
      :href="store.shopNowUrl"
      :label="buttonText"
      target="_blank"
      rel="noopener"
      primary
    )
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
import VButton from 'scripts/components/buttons/VButton.vue';
import { handleize } from 'scripts/filters/string.js';

  export default {
    name: "LocalStoreLocation",
    components: {
      VButton,
      Icon,
    },
    props: {
      index: Number,
      store: Object,
    },
    computed: {
      buttonText() {
        return this.store.availability ? "Shop Now" : "Learn More"
      },
      stockText() {
        if (this.store.availability === 'hidden') return
        return this.store.availability ? "In Stock" : "Out of Stock"
      },
      logoSrc() {
        const altLogoBrands = ['kroger', 'giant', 'hannaford', 'instacart', 'stop-shop', 'target', 'walmart']
        const storeHandle = handleize(this.store.retailerName)
        return altLogoBrands.includes(storeHandle) ? `${window.BVA.asset_url_root}${storeHandle}_75x.png` : this.store.retailerLogo;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .local-store {
    background-color: var(--color-grey-100);
    display: flex;
    flex-wrap: wrap;
    padding: 8px;
    margin-bottom: 8px;
    min-height: 88px;
    align-items: center;

    @include tablet-up {
      min-height: 0;
    }
  }

  .local-store__logo {
    max-width: 55px;
    width: 100%;
  }

  .local-store__address {
    color: var(--color-grey-800);
    margin-left: 16px;
    width: 100%;
    max-width: 100px;

    @include tablet-up {
      margin-left: 24px;
      max-width: 126px;
    }
  }

  .local-store__availability {
    color: var(--color-navy-500);
    margin-left: auto;
    font-size: 10px;
    max-width: 90px; 

    @include tablet-up {
      margin: 0 auto;
      max-width: 100px; 
      @include body--xs;
    }
  }

  .local-store__stock-icon {
    margin-right: 4px;
    margin-bottom: 3px;

    @include tablet-up {
      margin-right: 8px;
    }
  }

  .local-store__price {
    color: var(--color-navy-500);
    margin-left: 19px;
    width: 40px;

    @include tablet-up {
      margin-left: auto;
      margin-right: 10px;
    }
  }

  .btn--shop-now {
    background-color: var(--color-navy-500);
    border-color: var(--color-navy-500);
    color: var(--color-white);
    font-size: rem(12px);
    height: 32px;
    line-height: rem(16px);
    margin-top: 10px;
    min-width: 0;
    padding: 0;
    text-align: center;
    width: 100%;

    @include tablet-up {
      margin-top: 0;
      max-width: 111px;
    }
  }

</style>
